import { LocalMonth } from '@lemon/core/model/common'

export class AsiakasUriService {
  annaKayttajienRoolienPoistonTyoUri(asiakasAvain: string, tyoAvain: string): string {
    return 'tyojono/' + asiakasAvain + '/poista-kayttajien-rooleja/' + tyoAvain
  }

  annaMoniyritystuenMuodostusTyoUri(asiakasAvain: string, tyoAvain: string): string {
    return 'tyojono/' + asiakasAvain + '/moniyritystuki-muodostus/' + tyoAvain
  }

  annaListausAsiakkaanPaivitysTyoUri(asiakasAvain: string, tyojonoAvain: string): string {
    return 'tyojono/' + asiakasAvain + '/listaus-asiakkaan-paivitys/' + tyojonoAvain
  }

  annaAsiakkaanPostgresVientiTyoUri(asiakasAvain: string, tyojonoAvain: string): string {
    return 'tyojono/' + asiakasAvain + '/asiakas-postgres-export/' + tyojonoAvain
  }

  annaListausTilikausienPaivitysTyoUri(asiakasAvain: string, tyojonoAvain: string): string {
    return 'tyojono/' + asiakasAvain + '/listaus-tilikausien-paivitys/' + tyojonoAvain
  }

  annaListausHintojenPaivitysTyoUri(asiakasAvain: string, tyojonoAvain: string): string {
    return 'tyojono/' + asiakasAvain + '/listaus-hintojen-paivitys/' + tyojonoAvain
  }

  annaYtjTietojenPaivitysTyoUri(asiakasAvain: string, tyojonoAvain: string): string {
    return 'tyojono/' + asiakasAvain + '/ytj-tiedot/' + tyojonoAvain
  }

  annaSelvittelyreskontranKytkentaTyoUri(asiakasAvain: string, tyojonoAvain: string): string {
    return 'tyojono/' + asiakasAvain + '/selvittelyreskontran-kytkenta/' + tyojonoAvain
  }

  annaAsetaTyokieltoEmailLahetysTyoUri(asiakasAvain: string, tyojonoAvain: string): string {
    return 'tyojono/' + asiakasAvain + '/aseta-tyokielto/' + tyojonoAvain
  }

  annaLopetaTyokieltoEmailLahetysTyoUri(asiakasAvain: string, tyojonoAvain: string): string {
    return 'tyojono/' + asiakasAvain + '/lopeta-tyokielto/' + tyojonoAvain
  }

  annaListausSarakkeidenCollectionUri(kirjanpitajanAvain: string): string {
    return 'kirjanpitajat/' + kirjanpitajanAvain + '/asiakaslistauksen-sarakkeiden-arvot'
  }

  annaListausSarakkeenUri(kirjanpitajanAvain: string, asiakasAvain: string): string {
    return this.annaListausSarakkeidenCollectionUri(kirjanpitajanAvain) + '/' + asiakasAvain
  }

  annaListausSarakkeenHistoriaUri(kirjanpitajanAvain: string, asiakasAvain: string, tallennuksenAvain: string): string {
    return this.annaListausSarakkeenUri(kirjanpitajanAvain, asiakasAvain) + '/asiakaslistauksen-sarakkeiden-arvot-historia/' + tallennuksenAvain
  }

  annaAsiakasUri(asiakasAvain: string): string {
    return 'asiakkaat/' + asiakasAvain
  }

  annaAsiakkaanHistoriaUri(asiakasAvain: string, historiaAvain: string): string {
    return this.annaAsiakasUri(asiakasAvain) + '/historia/' + historiaAvain
  }

  annaListausAsiakasUri(asiakasAvain: string): string {
    return 'asiakkaat/' + asiakasAvain + '/asiakaslistaus/' + asiakasAvain
  }

  annaListausRuutuCollectionUri(asiakasAvain: string) {
    return 'asiakkaat/' + asiakasAvain + '/asiakaslistauksen-kuukausiruutu'
  }

  annaListausRuutuUri(asiakasAvain: string, kuukausi: LocalMonth): string {
    const month = ('' + kuukausi.month).padStart(2, '0')
    return this.annaListausRuutuCollectionUri(asiakasAvain) + '/' + asiakasAvain + '' + kuukausi.year + month
  }

  annaListausRuutuHistoriaUri(asiakasAvain: string, kuukausi: LocalMonth, historiaAvain: string): string {
    return this.annaListausRuutuUri(asiakasAvain, kuukausi) + '/asiakaslistauksen-kuukausiruutu-historia/' + historiaAvain
  }

  annaAsiakkaanKayttajatCollectionUri(asiakasAvain: string): string {
    return 'asiakkaat/' + asiakasAvain + '/kayttajat'
  }

  annaAsiakkaanKayttajaUri(asiakasAvain: string, kayttaja: string): string {
    return 'asiakkaat/' + asiakasAvain + '/kayttajat/' + kayttaja
  }

  annaAsiakkaanKayttajaHistoriaCollection(asiakasAvain: string, kayttaja: string): string {
    return 'asiakkaat/' + asiakasAvain + '/kayttajat/' + kayttaja + '/historia'
  }

  annaYtjTiedotUri(asiakasAvain: string) {
    return 'asiakkaat/' + asiakasAvain + '/ytj-tiedot/' + asiakasAvain
  }

  annaYtjTiedotHistoriaCollection(asiakasAvain: string) {
    return this.annaYtjTiedotUri(asiakasAvain) + '/historia'
  }

  annaYtjTiedotHistoriaUri(asiakasAvain: string, historiaAvain: string) {
    return this.annaYtjTiedotHistoriaCollection(asiakasAvain) + '/' + historiaAvain
  }

  annaAsiakastiedotUri(asiakasAvain: string) {
    return 'asiakkaat/' + asiakasAvain + '/asiakastiedot/' + asiakasAvain
  }

  annaAsiakastietojenHistoriaCollection(asiakasAvain: string) {
    return this.annaAsiakastiedotUri(asiakasAvain) + '/asiakastietojen-historia'
  }
  annaAsiakastietojenHistoriaUri(asiakasAvain: string, historiaAvain: string) {
    return this.annaAsiakastietojenHistoriaCollection(asiakasAvain) + '/' + historiaAvain
  }

  annaTyokieltoHistoriaCollectionUri(asiakasAvain: string) {
    return 'asiakkaat/' + asiakasAvain + '/tyokielto-historia'
  }

  annaTyokieltoHistoriaUri(asiakasAvain: string, historiaAvain: string) {
    return this.annaTyokieltoHistoriaCollectionUri(asiakasAvain) + '/' + historiaAvain
  }

  annaRiskiarvionHistoriaCollection(asiakasAvain: string) {
    return this.annaAsiakastiedotUri(asiakasAvain) + '/riskiarvion-historia'
  }

  annaRiskiarvionHistorianUri(asiakasAvain: string, historianAvain: string) {
    return this.annaAsiakastiedotUri(asiakasAvain) + '/riskiarvion-historia/' + historianAvain
  }

  annaRahanpesunSelvitysCollection(asiakasAvain: string) {
    return this.annaAsiakastiedotUri(asiakasAvain) + '/rahanpesun-selvitykset'
  }

  /** Storage bucket rahanpesu-selvitykset */
  annaRahanpesuSelvitysTiedostoStorageUri(asiakasAvain: string, selvitysAvain: string, fileName: string) {
    return asiakasAvain + '/' + selvitysAvain + '/' + fileName
  }

  annaRahanpesunSelvitysUri(asiakasAvain: string, selvitysAvain: string) {
    return this.annaRahanpesunSelvitysCollection(asiakasAvain) + '/' + selvitysAvain
  }

  annaKayttajaYhteystietoMuutosTyojonoUri(asiakasAvain: string, tyojonoAvain: string): string {
    return 'tyojono/' + asiakasAvain + '/kayttaja-yhteystieto-muutos/' + tyojonoAvain
  }
  annaTilastojenPaivitysTyoUri(asiakasAvain: string, tyojonoAvain: string): string {
    return 'tyojono/' + asiakasAvain + '/tilastojen-paivitys/' + tyojonoAvain
  }
}
